import React from 'react';
import { Meteor } from 'meteor/meteor';
import { withRouter } from 'react-router-dom';
import { withTracker } from 'meteor/react-meteor-data';
import { isEmpty, isNil } from 'lodash';

import TasksCollection from '../../../api/Tasks/Tasks';

import TaskList from '../../pages/TaskList';

const PER_PAGE = 6;
const SAVED_GROUP = 'Saved Tasks';

const SavedTasksContainer = props => (
  <TaskList itemsPerPage={PER_PAGE} networkError={false} {...props} />
);

export default withRouter(
  withTracker(({ searchValue, currentPage }) => {
    const skip = currentPage * PER_PAGE - PER_PAGE;
    const sort = {
      name: 1 // ascending
    };

    const taskQuery = {
      deleted: { $eq: 'no' },
      group: { $eq: SAVED_GROUP }
    };
    const unfilteredQuery = { ...taskQuery };

    const searchRegex = !isEmpty(searchValue) ? new RegExp(searchValue, 'i') : null;
    if (!isNil(searchRegex)) {
      taskQuery.label = searchRegex;
    }

    const sortOptions = { limit: PER_PAGE, skip, sort };
    const tasksSub = Meteor.subscribe('tasks');

    return {
      loading: !tasksSub.ready(),
      taskList: TasksCollection.find(taskQuery, sortOptions).fetch(),
      totalCount: TasksCollection.find(taskQuery).count(),
      filteredCount:
        TasksCollection.find(unfilteredQuery).count() - TasksCollection.find(taskQuery).count(),
      deletedTasks: TasksCollection.find({ deleted: { $ne: 'no' } }).fetch(),
      deletedCount: TasksCollection.find({ deleted: { $ne: 'no' } }).count()
    };
  })(SavedTasksContainer)
);
